// React
import * as React from 'react';

// Redux
import { connect } from 'react-redux';

// MainStore

// Components
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { NetworkManager, MethodRequest_e } from '../managers/NetworkManager';

// Import React FilePond
import { FilePond, registerPlugin } from "react-filepond";

// Import FilePond styles
import "filepond/dist/filepond.min.css";

import FilePondPluginImageExifOrientation from 'filepond-plugin-image-exif-orientation';
import FilePondPluginImageCrop from 'filepond-plugin-image-crop';
import FilePondPluginImageResize from 'filepond-plugin-image-resize';
import FilePondPluginImageTransform from 'filepond-plugin-image-transform';

// Register the plugin
registerPlugin(FilePondPluginImageExifOrientation, FilePondPluginImageCrop, FilePondPluginImageResize, FilePondPluginImageTransform);
interface State {
  animal: any;
  animals: any;
  date: string;
  description: any;
  descriptionUpdated: any;
  errors: Array<any>;
  product: any;
  users: any;
  products: any;
  employee: any;
  files: any;
  fromLocation: any;
  fromDate: Date | null;
  image: any;
  filesOnServer: any;
  isFinished: boolean;
  isUpdating: boolean;
  name: any;
  toLocation: any;
  toDate: Date | null;
}

interface Props {
  history: any;
  match: any;
  location: any;
  navigation: any;
}

let pond: any;

/**
 * @description UserProfile View
 * @author Lucas Fridez <lucas@fridez.dev>
 * @export
 * @class App
 * @extends {React.Component}
 */
export default connect<{}, {}, Props>((state) => state)(class BreedProfile extends React.Component<Props, State> {

  /**
   * Creates an instance of UserProfile.
   * @author Lucas Fridez <lucas@fridez.dev>
   * @param {*} props
   * @memberof App
   */
  constructor(props: any) {
    super(props);

    this.state = {
      animal: 0,
      animals: [],
      date: "",
      description: "",
      descriptionUpdated: "",
      employee: "",
      errors: [],
      files: "",
      filesOnServer: [],
      fromDate: null,
      fromLocation: "",
      image: "",
      isFinished: false,
      isUpdating: this.props.location.pathname.includes("Modifier"),
      name: "",
      product: "",
      products: [],
      toDate: null,
      toLocation: "",
      users: []
    };
  }

  async componentWillMount() {
    await NetworkManager.request(`breed/details/${this.props.match.params.id}`, MethodRequest_e.GET).then((result) => {
      this.setState({
        filesOnServer: Object.values(result.pictures)
      });
    });
    await NetworkManager.request(`breed/${this.props.match.params.id}`, MethodRequest_e.GET).then((result) => {
      this.setState({
        animal: result.animal,
        description: result.description,
        descriptionUpdated: result.description,
        name: result.name
      });
    });
  }

  deletePicture = (item: any) => {
    return async (event: React.MouseEvent<any>) => {
      NetworkManager.request(`breed/upload/${this.props.match.params.id}`, MethodRequest_e.DELETE, {
      filename: item});
      const array = [...this.state.filesOnServer]; // make a separate copy of the array
      const index = array.indexOf(item);
      if (index !== -1) {
        array.splice(index, 1);
        this.setState({filesOnServer: array});
      }
    };
  }

  /**
   * @description Render the UserProfileView in the Browser
   * @author Lucas Fridez <lucas@fridez.dev>
   * @returns
   * @memberof App
   */
  public render() {
    const id = this.props.match.params.id;
    const _this = this;
    return (
      <Paper elevation={1} className="form-paper-container">
        <Paper className="box-icon">
          <Icon style={{ color: "#fff" }}>edit</Icon>
        </Paper>
        <Typography variant="headline" style={{ height: "55px", alignItems: "center", display: "flex" }}>
          Images de la race : {this.state.name}</Typography>
        <Grid container={true} spacing={16} className="form-container">
          <Grid item={true} xs={12} className="form-field">
          <FilePond
          ref={(ref: any) => (pond = ref)}
          files={this.state.files}
          allowMultiple={true}
          imageResizeTargetHeight={1440}
          imageTransformOutputMimeType={'image/jpeg'}
          imageTransformOutputQuality={85}
          imageResizeUpscale={false}
          onprocessfile={(error: any, file: any) => {
            this.setState((prevState: State) => ({
              filesOnServer: [...prevState.filesOnServer, `${file.serverId}.jpg`]
            }));
            pond.removeFile(file.id);
          }}
          onupdatefiles={(fileItems: any) => {
            // Set currently active file objects to this.state
            this.setState({
              files: fileItems.map((fileItem: any) => fileItem.file)
            });
          }}
          server={`${NetworkManager.getApiServer()}/breed/upload/${this.props.match.params.id}`}
        />
          </Grid>
        </Grid>
        <Grid container={true} spacing={16} className="form-container">
          {this.state.filesOnServer.map(function(item: any, i: any) {
            const src = `${NetworkManager.getApiServer()}/img/breed/${id}/thumbnail/${item}`;
            return (
              <Grid item={true} xs={6} md={4} lg={2} xl={2} key={i} className="form-field">
                <img src={src} alt={`Image ${i}`}/>
                <Button variant="raised" color="secondary" className=" square"
                  onClick={_this.deletePicture(item)}>
                  Supprimer
                </Button>
              </Grid>
            );
          })}
        </Grid>
      </Paper>
    );
  }
});



// WEBPACK FOOTER //
// ./src/app/views/BreedProfileImage.tsx